module.exports = __webpack_public_path__ + "static/media/firebase.6f9d4ad5.png";